import { useRequestGetAccountingUsers, useRequestDeleteAccountingUser } from '@/hooks/httpRequest';
import { useFormAccountingUser } from '@/hooks/forms';
import { DataTablePageSizeEnum } from '@/enums';
import { useQueryParams } from '@/hooks';
import { useCallback } from 'react';

const useAccountingUsers = () => {

    const { values: [sortType, sortBy, limit, page, type, status, search] } = useQueryParams(
        ['sortType', 'sortBy', 'limit', 'page', 'type', 'status', 'search'],
        {
            limit: DataTablePageSizeEnum._15,
            page: 1
        }
    );

    const parseMultiValues = useCallback((value: unknown): string[] => {
        if (Array.isArray(value)) return value.filter(Boolean);
        if (typeof value === 'string' && value) return [value];
        return [];
    }, []);

    const result = useRequestGetAccountingUsers({
        sortType,
        sortBy,
        limit,
        page,
        type: parseMultiValues(type),
        status: parseMultiValues(status),
        search
    });
    const { create: createAccountingUser, seeDetails, edit } = useFormAccountingUser();
    const { trigger: triggerDelete } = useRequestDeleteAccountingUser();

    const accountingUsers = [...(result.data?.data ?? [])];

    const deleteAccountingUser = async (_id: string) => { await triggerDelete({ _id }); };

    return ({
        ...result,
        createAccountingUser,
        accountingUsers,
        seeDetails,
        edit,
        deleteAccountingUser
    });

};

export default useAccountingUsers;

